import Api from '@/services/Index';

const getCourse = async () => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/course/agreement/student-form');
}
const courseList = async () => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/wdc/course-list');
}
const startApplication = async () => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/course/agreement/start-application');
}
const storeCourseAgreement = async (data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post('/course/agreement/store-course',data);
}
const deleteSelectedCourse = async (id) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.delete(`/course/agreement/delete-course/${id}`);
}

const approvedApplication = async () => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get(`course/agreement/send-approve`)
};




export default {
    getCourse,
    courseList,
    startApplication,
    storeCourseAgreement,
    deleteSelectedCourse,
    approvedApplication
}
